import { useEffect } from "react";
import styles from "./styles.module.css";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { KEYBOARD_KEYS, EVENTS } from "const";
import { eventsEmitter } from "utils/events";

function TerminalForceAttachDialog({ handleClose, forceAttachTerminal }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === KEYBOARD_KEYS.ENTER) {
        forceAttachTerminal();
      }
    };
    const unsubscribeFn = eventsEmitter.on(EVENTS.KEY_DOWN, handleKeyDown);
    return unsubscribeFn;
  }, [forceAttachTerminal]);

  return (
    <div className={styles.popUp} style={{ borderRadius: "18px" }}>
      <Grid
        container
        className={styles.billContentWrapper}
        onClick={(e) => {
          e.stopPropagation();
        }}
        rowSpacing={1.5}
        style={{ marginTop: "24px" }}
      >
        <Grid item xs={12} pt={0} className={styles.header}>
          <h3>Force Attach Terminal</h3>
          <CloseRoundedIcon onClick={handleClose} className={styles.icon} />
        </Grid>
        <Grid item xs={12} className={styles.paragraph}>
          <span>
            The terminal is already attached! Forcing attachment will disconnect the current terminal. Are you sure you
            want to continue?
          </span>
        </Grid>
        <Grid item xs={12} className={styles.footSec}>
          <Button className={styles.buttonGray} onClick={handleClose}>
            Cancel
          </Button>
          <Button className={styles.buttonRed} onClick={forceAttachTerminal}>
            Attach
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default TerminalForceAttachDialog;
